// extracted by mini-css-extract-plugin
module.exports = {"root":"FallingLlama_root__3rWGa","gray":"FallingLlama_gray__2RYHs"};